const leftPad = (num: number) => ('00' + num).slice(-2);
export const ONE_DAY_MILLISECONDS = 1000 * 3600 * 24;

function renderMinutesFromMidnight(minutesFromMidnight: number, isEnd: boolean = false) {
  const totalHours = Math.floor(minutesFromMidnight / 60);
  const hours = totalHours % 24;
  const minutes = minutesFromMidnight % 60;
  if (totalHours === 24 && minutes === 0 && isEnd) {
    return '24.00';
  }
  return `${leftPad(hours)}.${leftPad(minutes)}`;
}

function getDateRangeDelta(startTime: Date, endTime: Date) {
  const daysDiff = Math.ceil((endTime.getTime() - startTime.getTime()) / ONE_DAY_MILLISECONDS);
  const now = new Date().getTime();
  const rangeStartDaysAgo = Math.ceil((now - startTime.getTime()) / ONE_DAY_MILLISECONDS);
  const rangeEndDaysAgo = Math.ceil((now - endTime.getTime()) / ONE_DAY_MILLISECONDS);
  return { daysDiff, rangeStartDaysAgo, rangeEndDaysAgo };
}

export { renderMinutesFromMidnight, getDateRangeDelta };
